import React from 'react';
import { CircularProgress } from 'src/components/PulseUI';

interface WidgetLoadingProps {
  'data-testid'?: string;
  'aria-label'?: string;
  className?: string;
}

const WidgetLoading: React.FC<WidgetLoadingProps> = ({
  'data-testid': testId,
  'aria-label': ariaLabel,
  className = 'flex items-center justify-center py-4',
}) => (
  <div className={className} data-testid={testId}>
    <CircularProgress size="sm" color="neutral" aria-label={ariaLabel} />
  </div>
);

export default WidgetLoading;
